import { createCacheStore } from '@lib/utils/cache';
import { OrgEmployeeRequestService } from '@api/OrgEmployeeRequestService';

/** Cached OrgEmployeeRequestService.getOrgEmployeeRequests(orgId, orgEmployeeId, params) reads. */
export const orgEmployeeRequestsCache = createCacheStore(
    'orgEmployeeRequest/requests',
    OrgEmployeeRequestService.getOrgEmployeeRequests,
);

/** Cached OrgEmployeeRequestService.getOrgEmployeeRequest(orgId, orgEmployeeId, requestId) reads. */
export const orgEmployeeRequestCache = createCacheStore(
    'orgEmployeeRequest/request',
    OrgEmployeeRequestService.getOrgEmployeeRequest,
);

/*
 * Request mutations (create/update/pattern/status/comment, both scopes)
 * call this — a single request's change can affect every list it appears
 * in, so the next read of any request list refetches.
 */
/** Drops all cached org employee request data (after request mutations). */
export const invalidateOrgEmployeeRequestData = (): void => {
    orgEmployeeRequestsCache.invalidateAll();
    orgEmployeeRequestCache.invalidateAll();
};
